import { useCallback } from "react"

const usePreventUnload = () => {
  const listener = useCallback((e: BeforeUnloadEvent) => {
    e.preventDefault()
    e.returnValue = ""
  }, [])

  return {
    add() {
      window.addEventListener("beforeunload", listener)
    },
    remove() {
      window.removeEventListener("beforeunload", listener)
    },
  }
}

export default usePreventUnload
